export const ADD_ROLE = 'ADD_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const POPULATE_ROLES = 'POPULATE_ROLES';

export const ADD_SUB_PLAN = 'ADD_SUB_PLAN';
export const UPDATE_SUB_PLAN = 'UPDATE_SUB_PLAN';
export const DELETE_SUB_PLAN = 'DELETE_SUB_PLAN';
export const POPULATE_SUB_PLANS = 'POPULATE_SUB_PLANS';

export const POPULATE_SUBPLAN_ASSIGNEE = 'POPULATE_SUBPLAN_ASSIGNEE';

export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const POPULATE_USERS = 'POPULATE_USERS';
export const RETRIEVE_USER = 'RETRIEVE_USER';
export const USER_SUB_LIST = 'USER_SUB_LIST';

export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const POPULATE_CAMPAIGNS = 'POPULATE_CAMPAIGNS';
export const POPULATE_EVENT_USERS = 'POPULATE_EVENT_USERS';

export const ADD_CAMPAIGN_USER = 'ADD_CAMPAIGN_USER';
export const UPDATE_CAMPAIGN_USER = 'UPDATE_CAMPAIGN_USER';
export const DELETECAMPAIGN__USER = 'DELETE_CAMPAIGN_USER';
export const POPULATE_CAMPAIGN_USERS = 'POPULATE_CAMPAIGN_USERS';

export const ADD_ORG = 'ADD_ORG';
export const UPDATE_ORG = 'UPDATE_ORG';
export const DELETE_ORG = 'DELETE_ORG';
export const POPULATE_ORGS = 'POPULATE_ORGS';
export const RETRIEVE_ORG = 'RETRIEVE_ORG';

export const ADD_SUB = 'ADD_SUB';
export const UPDATE_SUB = 'UPDATE_SUB';
export const DELETE_SUB = 'DELETE_SUB';
export const POPULATE_SUBS = 'POPULATE_SUBS';
export const RETRIEVE_SUB = 'RETRIEVE_SUB';

export const NOTIFICATION_OPERATION_SUCCESSFUL = 'NOTIFICATION_OPERATION_SUCCESSFUL';
export const NOTIFICATION_OPERATION_FAIL = 'NOTIFICATION_OPERATION_FAIL';
export const RESET_CRUD_NOTIFICATION = 'RESET_NOTIFICATION';
export const NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE';

export const ADD_DETAIL = 'ADD_DETAIL';

export const NERD_TRAINING = {
  LOADING: 'NERD_TRAINING_LOADING',
  ERROR: 'NERD_TRAINING_ERROR',
  SET_SUBMIT_MESSAGE: 'SET_SUBMIT_MESSAGE',
  UPDATE_ENTITY_RESULT: 'UPDATE_ENTITY_RESULT',
  INIT_ARTICLE_CONTENT: 'INIT_ARTICLE_CONTENT',
  SET_SUBMITTING: 'SET_SUBMITTING',
} as const;

export const ARTICLE = {
  POPULATE: 'POPULATE_ARTICLE',
  SELECTED: 'SELECTED_ARTICLE',
  RESET: 'RESET'
};

export const TARGET_LIST = {
  POPULATE: 'POPULATE_TARGET_LIST'
};

export const SAVED_SEARCH = {
  POPULATE: 'POPULATE_SAVED_SEARCH'
};

export const DATA = {
  ORG_POPULATE: 'POPULATE_ORG'
};

export const SECTOR = {
  LIST: 'SECTOR_LIST'
};

export const SCOUT_AI = {
  ADD_SCOUT_AI: 'ADD_SCOUT_AI',
  UPDATE_SCOUT_AI: 'UPDATE_SCOUT_AI',
  DELETE_SCOUT_AI: 'DELETE_SCOUT_AI',
  POPULATE_SCOUT_AIS: 'POPULATE_SCOUT_AIS',
  POPULATE_SCOUT_AIS_DATA: 'POPULATE_SCOUT_AIS_DATA',
  POPULATE_SELECTED_SCOUT_AIS: 'POPULATE_SELECTED_SCOUT_AIS',
  RETRIEVE_SCOUT_AI_RESULT: 'RETRIEVE_SCOUT_AI_RESULT',
  SHARE_SCOUT_AI: 'SHARE_SCOUT_AI'
};
export const KEY_DEV = {
  POPULATE_KEY_DEVS: 'POPULATE_KEY_DEVS',
  POPULATE_KEY_DEVS_LOG: 'POPULATE_KEY_DEVS_LOG',
  POPULATE_KEY_DEVS_REPORT: 'POPULATE_KEY_DEVS_REPORT',
  RETRIEVE_KEY_DEV: 'RETRIEVE_KEY_DEV',
  RETRIEVE_KEY_DEV_RULE: 'RETRIEVE_KEY_DEV_RULE',
  CHECK_UPDATING_STATUS: 'CHECK_UPDATING_STATUS',
  CHANGE_NAME: 'CHANGE_NAME',
  RETRIEVE_KEY_DEV_CORRECTION_HISTORY: 'RETRIEVE_KEY_DEV_CORRECTION_HISTORY',
  CHANGE_INDEX_CURRENT_VERSION: 'CHANGE_INDEX_CURRENT_VERSION',
  POPULATE_KEY_DEV_TOPICS: 'POPULATE_KEY_DEV_TOPICS',
  POPULATE_PUBLISHERS: 'POPULATE_PUBLISHERS',
  POPULATE_CLUSTER_DETAIL: 'POPULATE_CLUSTER_DETAIL',
  POPULATE_TARGET_CLUSTER: 'POPULATE_TARGET_CLUSTER',
  POPULATE_KEY_DEV_RELATED: 'POPULATE_KEY_DEV_RELATED',
  POPULATE_KEY_DEV_UPDATABLE_STATUS: 'POPULATE_KEY_DEV_UPDATABLE_STATUS',
  POPULATE_IS_PENDING_KEY_DEV_CORRECTION: 'POPULATE_IS_PENDING_KEY_DEV_CORRECTION',
  CLEAR_KEY_DEV_DETAIL: 'CLEAR_KEY_DEV_DETAIL',
};

export const SEER_DEMO = {
  REQUEST_SEER_PREDICTION: 'REQUEST_SEER_PREDICTION',
  GET_SEER_PREDICTION_STATUS: 'GET_SEER_PREDICTION_STATUS',
  RETRIEVE_SEER_PREDICTION: 'RETRIEVE_SEER_PREDICTION',
  RESET: 'RESET',
};

export const TAAS_CONFIG = {
  POPULATE: 'POPULATE_TAAS_CONFIG',
  SELECTED: 'SELECTED_TAAS_CONFIG',
  SET_ACTIVE: 'SET_ACTIVE',
};

export const AUTH = {
  VALIDATION: {
    RESULT: 'AUTH_VALIDATION_RESULT'
  }
};
export const TABLE_STATE = {
  CHANGE: 'CHANGE_TABLE_STATE',
  RESET: 'RESET_TABLE_STATE'
};

export const COMPANY = {
  COMPANY_DETAIL: 'COMPANY_DETAIL',
  RETRIEVE_IN_PROGRESS: 'COMPANY_RETRIEVE_IN_PROGRESS',
  COMPANY_PEOPLE: 'COMPANY_PEOPLE',
  COMPANY_RETRIEVE_BY_IDS: 'COMPANY_RETRIEVE_BY_IDS',
};
